import React, { useState, useEffect } from "react";

// Style //
import "./SubContractors.css";
import "rc-pagination/assets/index.css";

// Components //
import {
  PageHeading,
  SearchBar,
  DropDown,
  ButtonComp,
  SubContractorTable,
} from "../../common/components/index";
import Pagination from "rc-pagination";

// Hooks //
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";

// API's //
import { getSoleTradersApi } from "../../api/soleTraderApi";

// Actioms //
import {
  receivedError,
  requestSent,
  responseRecived,
} from "../../redux/actions/utilsActions";
import { soleTraderStatusEnum } from "../../utils/constants";

const SubContractors = () => {
  // Hooks //
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userToken } = useSelector((state) => state.user)
  const [searchParams, setSearchParams] = useSearchParams({ page: 1, show: 10 })

  const [soleTraders, setSoleTraders] = useState([]);
  const [currentPage, setCurrentPage] = useState();
  const [totalCount, setTotalCount] = useState(12);
  const [limitPerPage, setlimitPerPage] = useState(10);
  const [searchValue, setSearchValue] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("ALL");

  useEffect(() => {
    setCurrentPage(Number(searchParams.get("page")))

    getSoleTraderData(
      {
        page: searchParams.get("page"),
        limit: searchParams.get("show"),
        name: searchValue,
        status: (() => {
          if (selectedStatus === 'Pending Induction') {
            return soleTraderStatusEnum['MISSINGDOCS']
          } else if (selectedStatus === 'Pending RIGHT TO WORK') {
            return soleTraderStatusEnum['PENDING_RIGHT_TO_WORK']
          } else {
            return selectedStatus
          }
        })()
      }
    );
    setlimitPerPage(Number(searchParams.get("show")))
  }, [selectedStatus]);

  const getSoleTraderData = async (value) => {
    try {
      dispatch(requestSent());
      const data = await getSoleTradersApi(userToken, {
        page: value.page,
        limit: value.limit,
        name: value.name,
        status: value.status
      });
      setSoleTraders(data.data.rows);
      setTotalCount(data.data.count);
      dispatch(responseRecived());
    } catch (error) {
      dispatch(receivedError(error));
    }
  };

  const handleShow = (value) => {
    setlimitPerPage(value);
    setSearchParams({ page: 1, show: value })
    getSoleTraderData(
      {
        page: 1,
        limit: value,
        name: '',
      }
    );
  };

  const handleSelectStatus = (value) => {
    setSelectedStatus(value);
  };

  const handleSearch = async (value) => {
    setSearchValue(value);
    getSoleTraderData({
      page: 1,
      limit: limitPerPage,
      name: value,
    });
  };

  const updatePageHandler = (p) => {
    setSearchParams({ page: p, show: searchParams.get("show") })
    setCurrentPage(p);
    getSoleTraderData(
      {
        page: p,
        limit: limitPerPage,
        name: '',
      }
    );
  };

  const getSoleTraderStatus = (e) => {
    if (e === 'MISSINGDOCS') {
      return 'Pending Induction'
    } else if (e === 'PENDING_RIGHT_TO_WORK') {
      return 'Pending RIGHT TO WORK'
    } else {
      return e
    }
  }

  return (
    <div id="sub_contractor">
      <PageHeading title={"Sub-Contractors"} />
      <div className="filter_cont justify-content-between">
        <div className="d-flex col-6">
          <DropDown
            label={"Show"}
            listItems={["2", "8", "10", "15", "20", "25"]}
            onSelect={handleShow}
            value={limitPerPage}
          />
          <SearchBar
            onChange={handleSearch}
            value={searchValue}
            type={"text"}
            placeholder={"Search Sub-Contractor"}
          />
        </div>

        <ButtonComp
          onClick={() => navigate("/sub-contractors/add-subcontractor")}
          title={"Add Sub-Contractor"}
          width={"25%"}
        />
      </div>
      <DropDown
        width={'35%'}
        label={"Filter (Status)"}
        style={{ margin: '2rem 0 2rem auto' }}
        listItems={['ALL', ...Object.keys(soleTraderStatusEnum)].map(k => getSoleTraderStatus(k))}
        onSelect={handleSelectStatus}
        value={selectedStatus}
      />
      <div className="right-sec_cont">
        <SubContractorTable data={soleTraders} />
        <div className="pagination_cont">
          <Pagination
            pageSize={limitPerPage}
            onChange={updatePageHandler}
            current={currentPage}
            total={totalCount}
          />
        </div>
      </div>
    </div>
  );
};

export default SubContractors;